export const PaymentMethodCardDeclinedText = {
    generic_decline: "Votre carte a été refusée.",
    insufficient_funds: "Votre carte n'a pas suffisamment de fonds disponibles.",
    lost_card: "Votre carte a été refusée.",
    stolen_card: "Votre carte a été refusée.",

}

export const PaymentMethodErrorsText = {
    expired_card: "Votre carte a expiré.",
    incorrect_cvc: "Le code de sécurité de votre carte (cryptogramme ou code CVC) est invalide.",
    processing_error: "Une erreur s'est produite lors du traitement de votre carte. Veuillez réessayer ultérieurement.",
    incorrect_number: "Le numéro de la carte est invalide."
}

export const PaymentMethod3DSecureErrorsText = {
    setup_intent_authentication_failure: "L'authentification de votre méthode de paiement a échoué. Veuillez réessayer."
}

export function HandlePaymentMethodsError(error){
    if(error.type === "card_error"){
        if(error.code === "card_declined"){
            return Object.getOwnPropertyNames(PaymentMethodCardDeclinedText).indexOf(error.decline_code) > -1 ? PaymentMethodCardDeclinedText[error.decline_code] : PaymentMethodCardDeclinedText.generic_decline;
        }else{
            return Object.getOwnPropertyNames(PaymentMethodErrorsText).indexOf(error.code) > -1 ? PaymentMethodErrorsText[error.code] : PaymentMethodCardDeclinedText.generic_decline;
        }
    }else if(error.type === "invalid_request_error"){
        return Object.getOwnPropertyNames(PaymentMethod3DSecureErrorsText).indexOf(error.code) > -1 ? PaymentMethod3DSecureErrorsText[error.code] : PaymentMethodCardDeclinedText.generic_decline;
    }else{
        return PaymentMethodCardDeclinedText.generic_decline;
    }   
}